import { NotFoundComponent } from './../../shared/components/not-found/not-found.component';

export const notFoundRoute = {
  path: 'not-found',
  url: '/not-found',
  rolePermissions: ['all'],
  authenticationRequired: false,
  component: NotFoundComponent,
};
